licenses-notices-1 = BestCraft 是自由软件：您可以在遵守由自由软件基金会发布的 GNU Affero 通用公共许可协议的情况下重新分发且或修改软件；或第三版许可协议，或（根据您的选择）任何更新版本。
licenses-notices-2 = BestCraft 本着可用的意愿分发，但不作任何担保；甚至没有商业性的或对特定目的适用性的暗指。更多细节请参看 GNU Affero 通用公共许可协议。
licenses-notices-3 = 您应该随 BestCraft 收到一份 GNU Affero 通用公共许可协议。否则请参阅：http://www.gnu.org/licenses/
copyright-notices = 
    版权所有 2025 Tnze. All Rights Reserved.
    引用的FFXIV相关资源 Copyright © 2010 - 2025 SQUARE ENIX CO., LTD.

level = 等级
recipe-level = 配方等级
class-job-level = 特职等级
craftsmanship = 作业精度
control = 加工精度
craft-point = 制作力
progress = 进展
quality = 品质
durability = 耐久
steps = 工次
condition = 状态
difficulty = 难度
initial-quality = 初期品质
conditions = 制作状态
progress-divider = 作业难度系数
progress-modifier = 作业压制系数
quality-divider = 加工难度系数
quality-modifier = 加工压制系数
difficulty-factor = 配方难度系数
quality-factor = 配方品质系数
durability-factor = 配方耐久系数
material-quality-factor = 半成品品质贡献度

meals = 食品
medicines = 药品

name = 名称
amount = 数量

specialist = 专家

# 职业名
carpenter = 刻木匠
blacksmith = 锻铁匠
armorer = 铸甲匠
goldsmith = 雕金匠
leatherworker = 制革匠
weaver = 裁衣匠
alchemist = 炼金术士
culinarian = 烹调师

# 配装名称
default = 默认
common = 通用
custom = 自定义 { $id }

# 技能名
basic-synthesis = 制作
basic-touch = 加工
masters-mend = 精修
hasty-touch = 仓促
rapid-synthesis = 高速制作
observe = 观察
tricks-of-the-trade = 秘诀
waste-not = 俭约
veneration = 崇敬
standard-touch = 中级加工
great-strides = 阔步
innovation = 改革
final-appraisal = 最终确认
waste-not-ii = 长期俭约
byregot-s-blessing = 比尔格的祝福
precise-touch = 集中加工
muscle-memory = 坚信
careful-synthesis = 模范制作
manipulation = 掌握
prudent-touch = 俭约加工
reflect = 闲静
preparatory-touch = 坯料加工
groundwork = 坯料制作
delicate-synthesis = 精密制作
intensive-synthesis = 集中制作
trained-eye = 工匠的神速技巧
advanced-touch = 上级加工
prudent-synthesis = 俭约制作
trained-finesse = 工匠的神技
careful-observation = 设计变动
heart-and-soul = 专心致志
refined-touch = 精炼加工
daring-touch = 冒进
immaculate-mend = 巧夺天工
quick-innovation = 快速改革
trained-perfection = 工匠的绝技

# 技能描述
desc-basic-synthesis = 推动进展，效率：100，31级后效率：120。
desc-basic-touch = 提高品质，效率：100。
desc-masters-mend = 恢复30点耐久。
desc-hasty-touch = 提高品质，效率：100，不消耗制作力，成功率：60%。
desc-rapid-synthesis = 推动进展，效率：250，63级后效率：500，成功率：50%。
desc-observe = 放空一次作业，用于连击注视制作和注视加工。
desc-tricks-of-the-trade = 恢复20点制作力，只有在“高品质”及以上的状态下才能使用。
desc-waste-not = 耐久度的消耗量减少50%，持续4次作业。
desc-veneration = 推动进展的技能效率提高50%，持续4次作业。
desc-standard-touch = 提高品质，效率：125，与加工连击可降低制作力消耗。
desc-great-strides = 令下一次使用的加工系技能效果变为2倍，3次作业内有效。
desc-innovation = 提升品质的技能效率提高50%，持续4次作业。
desc-final-appraisal = 执行推进作业进度的技能时，让作业进度接近于完成时停止一次，5次作业内有效。
desc-waste-not-ii = 耐久度的消耗量减少50%，持续8次作业。
desc-byregot-s-blessing = 消耗内静提高品质，效率100~300，每档内静提升20效率。
desc-precise-touch = 提高品质，效率：150，提供两档内静，只有在“高品质”及以上的状态下才能使用。
desc-muscle-memory = 仅可在首次作业时发动，推动进展，效率：300，令下一次使用的制作系技能效果翻倍，5次作业内有效。
desc-careful-synthesis = 推动进展，效率：150，82级后效率：180。
desc-manipulation = 每次作业结束时恢复5点耐久，持续8次作业。
desc-prudent-touch = 提高品质，效率：100，只消耗5点耐久，无法在俭约状态下使用。
desc-reflect = 仅可在首次作业时发动，提高品质，效率：300，提供两档内静。
desc-preparatory-touch = 提高品质，效率：200，提供两档内静，消耗20点耐久。
desc-groundwork = 推动进展，效率：300，86级后效率：360，消耗20点耐久，耐久不足时效率减半。
desc-delicate-synthesis = 推动进展并提高品质，效率：100，94级后提高进展效率：150。
desc-intensive-synthesis = 推动进展，效率：400，只有在“高品质”及以上的状态下才能使用。
desc-trained-eye = 仅可在首次作业且用于等级低了10级及以上的配方时发动，提高最大品质的100%
desc-advanced-touch = 提高品质，效率：150，与中级加工连击可降低制作力消耗。
desc-prudent-synthesis = 推动进展，效率：180，只消耗5点耐久，无法在俭约状态下使用。
desc-trained-finesse = 只有内静的档数为10时才可以使用，提高品质，效率：100，不消耗耐久。
desc-careful-observation = 消耗一个能工巧匠图纸，改变作业状态，一次制作最多可使用3次，目前模拟器UI不支持切换制作状态。
desc-heart-and-soul = 消耗一个能工巧匠图纸，允许使用一次集中加工、集中制作或秘诀，一次制作最多可使用1次。

desc-refined-touch = 提高品质，效率：100，与加工连击可以额外获得一层内静。
desc-daring-touch = 提高品质，效率：150，不消耗制作力，成功率：60%。
desc-immaculate-mend = 耐久恢复到最大值。
desc-quick-innovation = 获得改革状态，持续1次作业，一次制作最多可使用1次。
desc-trained-perfection = 下一个会消耗耐久的技能耐久消耗变为0，一次制作最多可使用1次。

# 技能释放错误
DurabilityNotEnough = 耐久不足
CraftPointNotEnough = 制作力不足
CraftingAlreadyFinished = 制作已完成无法发动技能
PlayerLevelTooLow = 该技能尚未学会，玩家等级不足
RequireGoodOrExcellent = 该技能只有在“高品质”及以上的状态下才能使用
NotAllowedInWastNotBuff = 该技能在俭约及长期简约状态下无法使用
OnlyAllowedInFirstStep = 该技能仅可在首次作业时发动
LevelGapMustGreaterThanTen = 该技能仅可在首次作业且用于等级低了10级及以上的配方时发动
RequireInnerQuiet1 = 该技能只有在内静的档数大于1时才可以使用
RequireInnerQuiet10 = 该技能只有在内静的档数为10时才可以使用
CarefulObservationUsed3 = 设计变动最多使用三次
HeartAndSoulUsed = 专心致志一次制作只能使用一次
FocusNeverFailsAfterObserved = 注视在观察之后无法失败
RequireHastyTouchSuccessed = 必须在仓促成功后使用
QuickInnovationUsed = 快速改革一次制作只能使用一次
NotAllowedInInnovationBuff = 改革状态下无法发动快速改革
TrainedPerfectionUsed = 工匠的绝技一次制作只能使用一次

# 状态
normal = 通常
good = 高品质
excellent = 最高品质
poor = 低品质
centered = 安定
sturdy = 结实
pliant = 高效
malleable = 大进展
primed = 长持续
goodomen = 好兆头

# 更新器
update-available = 更新可用：v{ $version }
update-now = 现在更新
update-not-now = 下次再说
update-installing = 正在安装更新，请耐心等待
update-ask-relaunch = 更新已安装，是否重启应用？

update-pending = 正在更新中
update-error = 更新失败：{ $error }
update-done = 更新已完成
update-uptodate = 已是最新版本

update-started = 更新下载开始
update-progress = 更新下载中：{ $progress }
update-done = 更新下载结束

# Rust Errors
player-level-lower-than-recipe-requirement = 玩家等级未达到所选配方最低要求
unknown-recipe-level = 遇到了数据库中不存在的配方等级
solver-already-exist = 求解器已存在
solver-is-creating = 求解器已正在创建中
solver-doesn-t-exist = 求解器不存在
solver-isn-t-prepared = 求解器未准备完成

# Titles
attributes = 装备属性
select-recipe = 选择配方
custom-recipe = 自定义配方
bill-of-material = 物料清单
settings = 设置
